export default "src/content/themes/association-wordpress-theme/img/74715a5068eb87971f4f585330fb0815.png";